import "core-js/modules/es6.typed.uint8-array";
import "core-js/modules/es6.regexp.split";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins.js";
import axios from "axios";
import { getToken } from "@/libs/util";
import config from "@/config";
import { get_table_data, download_data, del_download } from "@/api/chuku";
import * as XLSX from "xlsx";
export default {
  name: "areaClass",
  mixins: [packageTableMixins],
  data: function data() {
    var _this = this;

    return {
      setting_id: this.$route.query.setting_id,
      // 新增表单数据
      formModel: {
        input: this.$route.query.model,
        //did
        hw_ver: null,
        project_id: null,
        merchant_code: null,
        dids: [],
        did: null
      },
      newForm: {
        settingName: "",
        productModel: ""
      },
      select1: [{
        name: "在线",
        value: 2
      }, {
        name: "离线",
        value: 1
      }],
      select2: [{
        name: "完成",
        value: 2
      }, {
        name: "失败",
        value: 3
      }, {
        name: "等待下发",
        value: 1
      }],
      select3: [],
      modelSelect1: [],
      modelSelect2: [],
      modelSelect3: [],
      openModel: false,
      form_filter: {
        online_status: null,
        setting_status: null,
        create_time: null
      },
      // 顶部按钮
      topButtonList1: [{
        name: "全部下发",
        // 直接使用中文，避免国际化问题
        type: "primary",
        icon: "ios-uplad",
        method: this.allXiafa
      }, {
        name: "新增",
        // 直接使用中文，避免国际化问题
        type: "primary",
        icon: "ios-add",
        method: this.addCom
      }],
      topButtonList: [{
        name: "查询",
        // 直接使用中文
        type: "primary",
        method: this.search
      }, {
        name: "重置",
        // 直接使用中文
        type: "error",
        method: this.reset
      }],
      tableData: [],
      columnsData: [{
        title: "设备ID",
        key: "did",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "在离线状态",
        key: "online_status",
        align: "left",
        minWidth: 120,
        tree: true,
        render: function render(h, _ref) {
          var row = _ref.row;
          var result = "";
          var color = "";

          if (row.online_status == 1) {
            color = "error";
            result = _this.$t("devicelist.offline");
          } else if (row.online_status == 2) {
            color = "success";
            result = _this.$t("devicelist.online");
          }

          return h("Tag", {
            props: {
              color: color
            }
          }, result);
        }
      }, {
        title: "设置状态",
        key: "setting_status",
        align: "left",
        minWidth: 120,
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var result = "";
          var color = "";

          if (row.setting_status == 2) {
            color = "success";
            result = _this.$t("完成");
          } else if (row.setting_status == 3) {
            color = "error";
            result = _this.$t("失败");
          } else if (row.setting_status == 1) {
            color = "primary";
            result = _this.$t("等待下发");
          }

          return h("Tag", {
            props: {
              color: color
            }
          }, result);
        }
      }, {
        title: "失败原因",
        key: "error_msg",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "下发时间",
        key: "create_time",
        align: "left",
        minWidth: 120,
        tree: true
      }, {
        title: "操作",
        // 直接使用中文
        key: "explain",
        align: "center",
        width: 300,
        render: function render(h, _ref3) {
          var row = _ref3.row;
          var arr = [];
          arr.push(h("Button", {
            style: {
              marginRight: "3px",
              marginBottom: "3px",
              color: "#2d8cf0"
            },
            props: {
              size: "small",
              type: "text"
            },
            on: {
              click: function click() {
                _this.setDevice(row);
              }
            }
          }, "下发设置" // 直接使用中文
          ));
          return h("div", arr);
        }
      }],
      tableLoading: false,
      tabletotallen: 0,
      border: true,
      stripe: true,
      moduleShow: false,
      reqBase: {
        page: 1,
        page_size: 10
      }
    };
  },
  computed: {
    // 避免国际化问题，直接返回中文
    placeholderText: function placeholderText() {
      return "请输入";
    }
  },
  components: {},
  methods: {
    fillDefaults: function fillDefaults(item) {
      item.data.forEach(function (field) {
        field.value = field.default; // 设置为默认值
      });
    },
    edit: function edit(row) {
      console.log("编辑", row); // 这里添加编辑逻辑
    },
    allXiafa: function allXiafa() {
      var _this2 = this;

      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceapply", {
        access_token: getToken(),
        setting_id: Number(this.setting_id),
        create_time: this.form_filter.create_time
      }).then(function (res) {
        console.log("设置设备", res);

        if (res.data.result === 0) {
          _this2.$Message.success("下发成功");
        } else {
          _this2.$Message.error("下发失败");
        }
      });
    },
    setDevice: function setDevice(row) {
      var _this3 = this;

      // 这里添加设置设备逻辑
      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceapply", {
        access_token: getToken(),
        setting_id: Number(this.setting_id),
        create_time: this.form_filter.create_time,
        did: row.did
      }).then(function (res) {
        console.log("设置设备", res);

        if (res.data.result === 0) {
          _this3.$Message.success("下发成功");
        } else {
          _this3.$Message.error("下发失败");
        }
      });
    },
    del: function del(row) {
      console.log("删除row", row);
      this.$Modal.confirm({
        title: "删除",
        content: "确定要删除 " + row.file_url + " 吗？",
        loading: true,
        onOk: function onOk() {}
      });
    },
    addCom: function addCom() {
      this.openModel = true; // 重置表单

      this.newForm = {
        settingName: "",
        productModel: ""
      };
    },
    handleLoadData: function handleLoadData(item, callback) {
      console.log("11111");
      var vm = this;

      var callbak = function callbak(res) {
        if (res.result === 0) {
          var data = res.body.list || [];

          for (var i in data) {
            var list = data[i];

            if (list.has_child === 1) {
              list._loading = false;
              list.children = [];
              list.parent_code = item.area_code;
              list.parent_name = item.area_name;
            }
          }

          callback(data);
        } else {// 处理错误
        }
      }; // area_list({
      //   page_size: -1,
      //   page: 1,
      //   parent_code: item.area_code,
      //   all: 1
      // })
      //     axios
      //     .post(`https://cn3.api.xcthings.com:6443/v3/smartbms/bmssettinglist`, {
      //        page: 1,
      //         page_size: 1,
      //         setting_name:this.form_filter.country_code,
      //         access_token: getToken()
      //     })
      // .then(res => {
      //   console.log('DSADSADA',res);
      //   callbak(res);
      // })
      // .catch(err => {
      //   // 处理错误
      // });

    },
    init: function init() {
      this.getPageSizeToStorage();
      this.getData();
    },

    /**
     * 初始化数据
     */
    formatDate: function formatDate(timestamp) {
      var date = new Date(timestamp * 1000);
      return date.toLocaleString();
    },
    getData: function getData() {
      var _this4 = this;

      console.log('this.form_filter', this.form_filter);
      this.tableData = [];
      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdevice", {
        access_token: getToken(),
        setting_id: Number(this.setting_id),
        online_status: this.form_filter.online_status,
        setting_status: this.form_filter.setting_status,
        create_time: this.form_filter.create_time
      }).then(function (res) {
        _this4.tabletotallen = res.data.body.total;
        _this4.tableData = res.data.body.info.map(function (item) {
          return _objectSpread({}, item, {
            create_time: _this4.formatDate(item.create_time)
          });
        });
      }).catch(function (err) {
        _this4.tableLoading = false;
      });
    },

    /**
     * 翻页
     */
    pageonChange: function pageonChange(index) {
      this.reqBase.page = index;
      this.getData();
    },

    /**
     * 筛选
     */
    showSearchParel: function showSearchParel() {
      this.$refs.search.expandPanel();
    },
    search: function search() {
      this.init();
    },
    reset: function reset() {
      this.form_filter = {
        online_status: null,
        setting_status: null,
        create_time: null
      };
      this.search();
    },
    handleOk: function handleOk() {
      var _this5 = this;

      // 检查是否有勾选的组
      if (this.formModel.did) {
        // 使用中文逗号拆分字符串
        var ids = this.formModel.did.split('-').map(function (id) {
          return id.trim();
        }); // 清空 dids 数组，确保不重复添加

        this.formModel.dids = []; // 将每个 ID 添加到 dids 数组中

        ids.forEach(function (id) {
          if (id) {
            // 检查 ID 是否不为空
            _this5.formModel.dids.push(id);
          }
        });
      } // 输出 dids 以进行调试


      console.log(this.formModel.dids);
      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdeviceadd", {
        access_token: getToken(),
        setting_id: Number(this.setting_id),
        hw_ver: this.formModel.hw_ver,
        project_id: this.formModel.project_id,
        merchant_code: this.formModel.merchant_code,
        dids: this.formModel.dids
      }).then(function (res) {
        if (res.data.result === 0) {
          _this5.$Message.success("新增成功");

          _this5.getHistory();

          _this5.openModel = false;
          _this5.formModel = {
            input: _this5.$route.query.model,
            //did
            hw_ver: null,
            project_id: null,
            merchant_code: null,
            dids: [],
            did: null
          };
        } else {
          _this5.$Message.error("新增失败");
        }
      });
    },
    cancel: function cancel() {
      console.log("取消");
      this.openModel = false;
      this.formModel = {
        input: this.$route.query.model,
        //did
        hw_ver: null,
        project_id: null,
        merchant_code: null,
        dids: [],
        did: null
      };
    },
    handleUpload: function handleUpload(file) {
      var _this6 = this;

      var reader = new FileReader();

      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = XLSX.read(data, {
          type: "array"
        }); // 获取工作表数据

        var firstSheet = workbook.Sheets[workbook.SheetNames[0]];
        var jsonData = XLSX.utils.sheet_to_json(firstSheet, {
          header: 1
        });
        jsonData = jsonData.slice(1).flat();
        console.log(jsonData); // 输出处理后的数据

        _this6.formModel.dids = jsonData; // 在此处处理数据，例如存入状态管理或进一步处理
      };

      reader.readAsArrayBuffer(file);
      return false;
    },
    // 获取历史下拉
    getHistory: function getHistory() {
      var _this7 = this;

      axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingdevicehis", {
        setting_id: Number(this.setting_id),
        access_token: getToken()
      }).then(function (res) {
        console.log("resres", res.data.body.history);
        _this7.select3 = res.data.body.history;
        _this7.form_filter.create_time = res.data.body.history[0];
      });
    }
  },
  mounted: function mounted() {
    var _this8 = this;

    this.$set(this.reqBase, "project_code", this.$store.state.user.projectCode);
    this.getHistory();
    setTimeout(function () {
      _this8.init();
    }, 1000);
    axios.post("https://cn3.api.xcthings.com:9823/v3/smartbms/bmssettingselector", {
      php_token: getToken(),
      access_token: getToken()
    }).then(function (res) {
      _this8.modelSelect1 = res.data.body.hw_ver;
      _this8.modelSelect2 = res.data.body.project_id;
      _this8.modelSelect3 = res.data.body.info;
    });
  },
  created: function created() {},
  destroyed: function destroyed() {
    window.onresize = null;
  }
};